<template>
    <div v-if="showModal" class="modal-container">
      <div class="fixed inset-0 bg-black bg-opacity-40 backdrop-blur-sm z-40"></div>

    <div class="modal-content w-[550px] relative bg-white m-auto flex-col flex rounded-lg z-50">
        <div  class="w-full border-b-[1px] mb-4 px-6 py-4">

          <p class="text-[18px] text-grayDark font-bold">{{ modalTitle }} {{ projectName }}
          </p>        
        </div>
        <form @submit.prevent="submitModal" class="overflow-y-auto px-6 ">
          <!-- <div class="mb-4">
            <label class="block text-[13px] font-medium text-grayDark">Select Project</label>
            <select v-model="selectedProject" class="mt-1 block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-blue-500 focus:border-blue-500 sm:text-sm bg-[#F6F8F9]" required>
              <option v-for="project in projects" :key="project.project_id" :value="project.project_id">
                {{ project.project_name }}
              </option>
            </select>
          </div> -->
          <!-- <div class="mb-4">
            <label class="block text-[13px] font-medium text-grayDark">Project</label>
              <p class="text-[16px] text-grayDark font-medium">{{ projectName }}</p>
          </div> -->
          <div class="mb-4">
            <label class="block text-[13px] font-medium text-grayDark">Invite by email</label>
            <div class="relative">
              <input 
                v-model="searchQuery"
                @focus="showDropdown = true"
                @blur="hideDropdown"
                @input="filterTalents"
                type="text" 
                placeholder="Search team members by name or email..."
                class="mt-1 block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-blue-500 focus:border-blue-500 sm:text-sm bg-[#F6F8F9]"
                autocomplete="off"
              />
              <div 
                v-if="showDropdown && filteredTalents.length > 0" 
                class="absolute z-10 w-full mt-1 bg-white border border-gray-300 rounded-md shadow-lg max-h-60 overflow-y-auto"
              >
                <div 
                  v-for="talent in filteredTalents" 
                  :key="talent.talent_id"
                  @mousedown="selectTalent(talent)"
                  class="px-3 py-2 hover:bg-gray-100 cursor-pointer text-sm"
                >
                  {{ talent.user.first_name }} {{ talent.user.last_name }} - {{ talent.user.email }}
                </div>
              </div>
              <div 
                v-if="showDropdown && filteredTalents.length === 0 && searchQuery" 
                class="absolute z-10 w-full mt-1 bg-white border border-gray-300 rounded-md shadow-lg"
              >
                <div class="px-3 py-2 text-gray-500 text-sm">No team members found</div>
              </div>
            </div>
          </div>
        
          <div class="mb-4">
            <label class="block text-[13px] font-medium text-grayDark">Select Position</label>
            <input 
              v-model="position" 
              type="text" 
              placeholder="Enter position (e.g., Developer, Designer)"
              class="mt-1 block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-blue-500 focus:border-blue-500 sm:text-sm bg-[#F6F8F9]" 
              required
            />
          </div>


          <div class="flex justify-end mb-4 text-[14px]">
            <button type="button" class="mr-4 py-2 px-4 bg-primaryLight border border-grayLight text-grayDark rounded" @click="$emit('close')">Cancel</button>
            <button 
              type="submit" 
              class="flex items-center  gap-2 py-2 px-4 bg-primaryDarkBg w-[146px] h-[42px] text-white rounded"
              :disabled="loading"
              >
              Add Member
            </button>
        </div>
        </form>
    </div>
  </div>
</template>

<script>
import dayjs from 'dayjs';
import apiClient from '@/axios';


export default {
  name: 'AddProjectMemberModal',
  components: {
  },
  props: {
    showModal: {
      type: Boolean,
      required: true
    },
    projectName: {
      type: String,
      required: false,
      default: '',
    },
    projectId: {
      type: Number,
      required: true,
    },

  },
  data() {
    return {
      selectedTalent: '', // Selected talent ID from the dropdown
      selectedProject: '', // Selected talent ID from the dropdown
      modalTitle: 'Add Team Member to',
      position: '',
      // joinDate: '',
      talents: [],
      filteredTalents: [],
      searchQuery: '',
      showDropdown: false,
      loading: false, // Loading state
    };
  },
  watch: {
    showModal(newVal) {
      if (newVal) {
        this.fetchTalents();
        // Reset search state when modal opens
        this.searchQuery = '';
        this.selectedTalent = '';
        this.showDropdown = false;
      }
    }
  },
  computed: {
    isAdmin() {
      return this.$store.getters.isAdmin;
    },
    isManager() {
      return this.$store.getters.isManager;
    },
    isTalent() {
      return this.$store.getters.isTalent;
    },
  },
  methods: {
    async submitModal() {
      this.loading = true;
      
      if (!this.selectedTalent) {
        this.$toast.error('Talent ID is required.');
        this.loading = false;
        return; 
      }

      const projectMemberData = {
        project_id: this.projectId,
        talent_id: this.selectedTalent.talent_id,
        position: this.position,
        join_date: dayjs().toISOString(),
      };


      try {
        // const endpoint = `/web/projects/${this.selectedProject}/project_members/?talent_id=${this.selectedTalent}`;
        const endpoint = `/web/projects/${this.projectId}/project_members/?talent_id=${this.selectedTalent.talent_id}`;

        await apiClient.post(endpoint, projectMemberData);
        
        this.$toast.success('Project member added successfully!');
        console.log("Emitting member-added event with message");

        this.$emit('member-added', 'Project member added successfully!');
        console.log("member added")
        this.$emit('close'); // Close the modal
      } catch (error) {
        this.showError = true;
        this.errorMessage = error.response?.data?.detail || 'Failed to add project member. Please try again.';
        console.error('Error adding project member:', error);
      } finally {
        this.loading = false; // End loading
      }
    },
    async fetchTalents() {
      try {
        if (this.isAdmin || this.isManager) {
          const response = await apiClient.get(`/web/talents/not-in-project/${this.projectId}`,
            {
              params: { page_size: 100 },
            }
          )
          this.talents = response.data.data
          this.filteredTalents = this.talents.filter(t => t.user)
        }
      } catch (error) {
        console.error('Error fetching talents:', error)
      }
    },
    filterTalents() {
      if (!this.searchQuery.trim()) {
        this.filteredTalents = this.talents.filter(t => t.user)
        return
      }
      
      const query = this.searchQuery.toLowerCase()
      this.filteredTalents = this.talents.filter(talent => {
        if (!talent.user) return false
        
        const fullName = `${talent.user.first_name} ${talent.user.last_name}`.toLowerCase()
        const email = talent.user.email.toLowerCase()
        
        return fullName.includes(query) || email.includes(query)
      })
    },
    selectTalent(talent) {
      this.selectedTalent = talent
      this.searchQuery = `${talent.user.first_name} ${talent.user.last_name} - ${talent.user.email}`
      this.showDropdown = false
    },
    hideDropdown() {
      // Delay hiding to allow click events to process
      setTimeout(() => {
        this.showDropdown = false
      }, 200)
    },
    // async fetchProjects() {
    //   try {
    //     const response = await apiClient.get('/web/projects_all')
    //     this.projects = response.data.data
    //   } catch (error) {
    //     console.error('Error fetching projects:', error)
    //   }
    // },
    clearErrorMessage() {
      // Clearing moved to toast
    },
  },
  created() {
    this.fetchTalents()
  },
  mounted() {
  }
};
</script>

<style scoped>
.modal-container {
  display: flex;
  align-items: center;
  justify-content: center;
  position: fixed;
  inset: 0;
  z-index: 50;
}

.smoke-light {
  background-color: rgba(0, 0, 0, 0.5);
}

.modal-content {
  position: relative;
  z-index: 60;
}
</style>